import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'classnames';
import translate from '../../../../commonComponents/translate';
import LevelObjectives from './LevelObjectives';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import { newFormatPrice } from '../../../../services/utilityFunctions';
import ProgressWithTarget from '../../../academy/list/enrolledItem/ProgressWithTarget';
import InfoIcon from '../../../../commonComponents/icons/InfoIcon';
import MetaContext from '../../../../contextProviders/MetaContext';

const tabs = ['elitePayplan', 'executivePayplan', 'businessPayplan'];

function PayplanTabs(props) {
  const { t, data, levelObjectives, user } = props;

  const {
    totalElitePartnerBonus,
    totalEliteManagerBonus,
    totalInfinitePartnerBonus,
    totalInfiniteManagerBonus,
    totalPersonalVA,
    totalGroupVA,
    totalMatchingBonus,
    eliteBonusThreshold,
    infiniteBonusThreshold,
    elitePartnerMinimumBonus,
    eliteManagerMinimumBonus,
    totalUniLevel,
    recruited,
    percentageEliteManager,
    totalVAG1,
    totalSale,
    totalBusinessBonus,
    totalInfiniteBusinessBonus,
    infiniteBusinessThreshold,
    eliteBusinessMinimumBonus,
    currentSaleCommission,
    totalCA,
  } = data;

  const [selectedTab, setSelectedTab] = useState('elitePayplan');

  const recruitments = Array.from({ length: 3 }, (_, i) => i + 1);

  const { branding = {} } = useContext(MetaContext);

  return (
    <>
      <div className="career-tabs">
        {tabs.map(tab => (
          <div
            className={
              selectedTab === tab ? 'career-tab-selected' : 'career-tab'
            }
            key={tab}
            onClick={() => setSelectedTab(tab)}
          >
            {t(`report.laborigin.summary.${tab}`)}
          </div>
        ))}
      </div>
      {selectedTab === 'elitePayplan' && (
        <div className="tab-content">
          <div className="cards">
            <div
              className="align-self-stretch card your-level"
              style={{ justifyContent: 'center' }}
            >
              <div className="title">
                <img
                  src="/images/wallet.svg"
                  alt="wallet"
                  className="wallet-icon"
                />
                {t('report.laborigin.summary.commissionElite')}
              </div>
              <div className="amount">
                {newFormatPrice(
                  totalElitePartnerBonus +
                    totalEliteManagerBonus +
                    totalInfinitePartnerBonus +
                    totalInfiniteManagerBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
            <div className="align-self-stretch flex-item orange-background">
              <div className="description">
                {t('report.laborigin.summary.elitePartnerBonus')}
              </div>
              <div className="value">
                {newFormatPrice(
                  totalElitePartnerBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
            <div className="align-self-stretch flex-item blue-background">
              <div className="description">
                {t('report.laborigin.summary.infiniteBonusVendor')}
              </div>
              <div className="value">
                {newFormatPrice(
                  totalInfinitePartnerBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
            <div className="align-self-stretch flex-item orange-background">
              <div className="description">
                {t('report.laborigin.summary.eliteManagerBonus')}
              </div>
              <div className="value">
                {newFormatPrice(
                  totalEliteManagerBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
            <div className="align-self-stretch flex-item blue-background">
              <div className="description">
                {t('report.laborigin.summary.infiniteGroupBonusVendor')}
              </div>
              <div className="value">
                {newFormatPrice(
                  totalInfiniteManagerBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
          </div>
          <div className="progress-bars">
            <div className="progress-bar-container">
              <div className="text">
                {t('report.neofin.personalVA')}: {totalPersonalVA}&nbsp;
                {t('commissions.userCommissions.va')}
                <span>
                  <InfoIcon
                    width={20}
                    height={20}
                    color={branding?.primaryColor}
                    tooltip={t('report.laborigin.tooltip.personalVA')}
                  />
                </span>
              </div>
              <div className="progress-label-container">
                <div className="course-progress">
                  <div className="course-progress-label-container">
                    <div className="course-progress-label">
                      {t('report.laborigin.summary.personalBonus')}
                    </div>
                    <div className="course-progress-label-percentage">
                      {percentageEliteManager} %
                    </div>
                  </div>
                </div>
              </div>
              <div className="progress-label-container">
                <ProgressWithTarget
                  progress={Math.min(
                    (totalPersonalVA / elitePartnerMinimumBonus) * 100,
                    100,
                  )}
                  showLabel
                  label={t(
                    'report.laborigin.summary.elitePartnerBonusThreshold',
                  )}
                  target={`${elitePartnerMinimumBonus} ${t(
                    'commissions.userCommissions.va',
                  )}`}
                />
              </div>
              <div className="progress-label-container">
                <ProgressWithTarget
                  progress={Math.min(
                    (totalPersonalVA / infiniteBonusThreshold) * 100,
                    100,
                  )}
                  showLabel
                  label={t(
                    'report.laborigin.summary.infiniteVendorBonusThreshold',
                  )}
                  target={`${infiniteBonusThreshold} ${t(
                    'commissions.userCommissions.va',
                  )}`}
                />
              </div>
            </div>
            <div className="progress-bar-container">
              <div className="text">
                {t('report.laborigin.summary.VAG1')}: {totalVAG1}&nbsp;
                {t('commissions.userCommissions.va')}
                <span>
                  <InfoIcon
                    width={20}
                    height={20}
                    color={branding?.primaryColor}
                    tooltip={t('report.laborigin.tooltip.VAG1')}
                  />
                </span>
              </div>
              <div className="progress-label-container">
                <ProgressWithTarget
                  progress={Math.min(
                    (totalVAG1 / eliteManagerMinimumBonus) * 100,
                    100,
                  )}
                  showLabel
                  showPercent={false}
                  label={t(
                    'report.laborigin.summary.eliteManagerBonusThreshold',
                  )}
                  target={`${eliteManagerMinimumBonus} ${t(
                    'commissions.userCommissions.va',
                  )}`}
                />
              </div>
              <div className="progress-recruitment-wrapper">
                <div className="label">
                  {t('report.laborigin.summary.recruitment')}
                  <span>
                    <InfoIcon
                      width={20}
                      height={20}
                      color={branding?.primaryColor}
                      tooltip={t('report.laborigin.tooltip.activeDistributors')}
                    />
                  </span>
                </div>
                <div className="progress-recruitment-container">
                  {recruitments.map(index => (
                    <div
                      className={clsx('progress-recruitment', {
                        completed: recruited >= index,
                      })}
                    >
                      {index}
                    </div>
                  ))}
                </div>
              </div>
              <div className="progress-label-container">
                <ProgressWithTarget
                  progress={Math.min(
                    (totalVAG1 / eliteBonusThreshold) * 100,
                    100,
                  )}
                  showLabel
                  showPercent={false}
                  label={t(
                    'report.laborigin.summary.infiniteGroupVendorBonusThreshold',
                  )}
                  target={`${eliteBonusThreshold} ${t(
                    'commissions.userCommissions.va',
                  )}`}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedTab === 'executivePayplan' && (
        <div className="tab-content">
          <div className="cards">
            <div
              className="align-self-stretch card your-level"
              style={{ justifyContent: 'center' }}
            >
              <div className="title">
                <img
                  src="/images/wallet.svg"
                  alt="wallet"
                  className="wallet-icon"
                />
                {t('report.laborigin.summary.commissionExecutive')}
              </div>
              <div className="amount">
                {newFormatPrice(
                  totalMatchingBonus + totalUniLevel,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
            <div className="align-self-stretch flex-item orange-background">
              <div className="description">
                {t('report.laborigin.summary.unilevel')}
              </div>
              <div className="value">
                {newFormatPrice(totalUniLevel, false, user?.userPrice?.code)}
              </div>
            </div>
            <div className="align-self-stretch flex-item blue-background">
              <div className="description">
                {t('report.laborigin.summary.matchingBonus')}
              </div>
              <div className="value">
                {newFormatPrice(
                  totalMatchingBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
            <div className="align-self-stretch flex-item orange-dashed">
              <div className="description">
                {t('report.laborigin.summary.personalVA')}
              </div>
              <div className="value">{totalPersonalVA} VA</div>
              <span className="info">
                <InfoIcon
                  width={20}
                  height={20}
                  color={branding?.primaryColor}
                  tooltip={t('report.laborigin.tooltip.personalVA')}
                />
              </span>
            </div>
            <div className="align-self-stretch flex-item green-dashed">
              <div className="description">
                {t('report.laborigin.summary.groupVA')}
              </div>
              <div className="value">{totalGroupVA} VA</div>
              <span className="info">
                <InfoIcon
                  width={20}
                  height={20}
                  color={branding?.primaryColor}
                  tooltip={t('report.laborigin.tooltip.groupVA')}
                />
              </span>
            </div>
          </div>
          {levelObjectives && (
            <div>
              <LevelObjectives data={levelObjectives} />
            </div>
          )}
        </div>
      )}
      {selectedTab === 'businessPayplan' && (
        <div className="tab-content">
          <div className="cards">
            <div
              className="align-self-stretch card your-level"
              style={{ justifyContent: 'center' }}
            >
              <div className="title">
                <img
                  src="/images/wallet.svg"
                  alt="wallet"
                  className="wallet-icon"
                />
                {t('report.laborigin.summary.commissionEliteBusiness')}
              </div>
              <div className="amount">
                {newFormatPrice(
                  totalInfiniteBusinessBonus + totalSale + totalBusinessBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
            <div className="align-self-stretch flex-item orange-background">
              <div className="description">
                {t('report.laborigin.summary.commissionSale')}
              </div>
              <div className="value">
                {newFormatPrice(totalSale, false, user?.userPrice?.code)}
              </div>
            </div>
            <div className="align-self-stretch flex-item blue-background">
              <div className="description">
                {t('report.laborigin.summary.eliteBusinessBonus')}
              </div>
              <div className="value">
                {newFormatPrice(
                  totalBusinessBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
            <div className="align-self-stretch flex-item orange-background">
              <div className="description">
                {t('report.laborigin.summary.infiniteBusinessBonus')}
              </div>
              <div className="value">
                {newFormatPrice(
                  totalInfiniteBusinessBonus,
                  false,
                  user?.userPrice?.code,
                )}
              </div>
            </div>
          </div>
          <div className="progress-bars">
            <div className="progress-bar-container">
              <div className="text-top-container">
                <div className="text">
                  {t('report.laborigin.summary.CA')}:&nbsp;
                  {newFormatPrice(totalCA, true, user?.userPrice?.code)}
                  <span>
                    <InfoIcon
                      width={20}
                      height={20}
                      color={branding?.primaryColor}
                      tooltip={t('report.laborigin.tooltip.CA')}
                    />
                  </span>
                </div>
                <div className="text">
                  {t('report.laborigin.summary.VAG1')}: {totalVAG1}&nbsp;
                  {t('commissions.userCommissions.va')}
                  <span>
                    <InfoIcon
                      width={20}
                      height={20}
                      color={branding?.primaryColor}
                      tooltip={t('report.laborigin.tooltip.VAG1')}
                    />
                  </span>
                </div>
              </div>
              <div className="progress-bar-business-container">
                <div
                  className="progress-bar-business"
                  style={{ paddingTop: 10 }}
                >
                  <div className="progress-label-container">
                    <div className="course-progress">
                      <div className="course-progress-label-container">
                        <div className="course-progress-label">
                          {t('report.laborigin.summary.saleCommission')}
                        </div>
                        <div className="course-progress-label-percentage">
                          {currentSaleCommission} %
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="progress-recruitment-wrapper">
                    <div className="label">
                      {t('report.laborigin.summary.recruitment')}
                      <span>
                        <InfoIcon
                          width={20}
                          height={20}
                          color={branding?.primaryColor}
                          tooltip={t(
                            'report.laborigin.tooltip.activeDistributors',
                          )}
                        />
                      </span>
                    </div>
                    <div className="progress-recruitment-container">
                      {recruitments.map(index => (
                        <div
                          className={clsx('progress-recruitment', {
                            completed: recruited >= index,
                          })}
                        >
                          {index}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="progress-bar-business">
                  <div className="progress-label-container">
                    <ProgressWithTarget
                      progress={Math.min(
                        (totalVAG1 / eliteBusinessMinimumBonus) * 100,
                        100,
                      )}
                      showLabel
                      showPercent={false}
                      label={t(
                        'report.laborigin.summary.eliteBusinessBonusThreshold',
                      )}
                      target={`${eliteBusinessMinimumBonus} ${t(
                        'commissions.userCommissions.va',
                      )}`}
                    />
                  </div>
                  <div className="progress-label-container">
                    <ProgressWithTarget
                      progress={Math.min(
                        (totalVAG1 / infiniteBusinessThreshold) * 100,
                        100,
                      )}
                      showLabel
                      showPercent={false}
                      label={t(
                        'report.laborigin.summary.infiniteBusinessBonusThreshold',
                      )}
                      target={`${infiniteBusinessThreshold} ${t(
                        'commissions.userCommissions.va',
                      )}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

PayplanTabs.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    totalElitePartnerBonus: PropTypes.number,
    totalEliteManagerBonus: PropTypes.number,
    totalInfinitePartnerBonus: PropTypes.number,
    totalInfiniteManagerBonus: PropTypes.number,
    totalPersonalVA: PropTypes.number,
    totalGroupVA: PropTypes.number,
    totalMatchingBonus: PropTypes.number,
    totalEliteBonus: PropTypes.number,
    eliteBonusThreshold: PropTypes.number,
    infiniteBonusThreshold: PropTypes.number,
    elitePartnerMinimumBonus: PropTypes.number,
    eliteManagerMinimumBonus: PropTypes.number,
    totalUniLevel: PropTypes.number,
    recruited: PropTypes.number,
    percentageEliteManager: PropTypes.number,
    totalVAG1: PropTypes.number,
    totalSale: PropTypes.number,
    totalBusinessBonus: PropTypes.number,
    totalInfiniteBusinessBonus: PropTypes.number,
    infiniteBusinessThreshold: PropTypes.number,
    eliteBusinessMinimumBonus: PropTypes.number,
    currentSaleCommission: PropTypes.number,
    totalCA: PropTypes.number,
  }).isRequired,
  levelObjectives: PropTypes.shape({}).isRequired,
  user: PropTypes.shape(UserProp.propType).isRequired,
};

export default translate(PayplanTabs);
